import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../config";
import Logo from "../../assets/img/logo.png";
import { FaWhatsapp } from "react-icons/fa";

const PublicForm = () => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [visitPurpose, setVisitPurpose] = useState([]);
  const [visitorId, setVisitorId] = useState("");
  const [formData, setFormData] = useState({
    visitorID: "",
    name: "",
    mobileNumber: "",
    category: "",
    email: "",
    address: "",
    purpose: "",
    toMeet: "",
    query: "",
    salutation: "", // Add salutation
    additionalName: "", // Add additionalName
    dob: "", // Add dob (date of birth)
    whatsappAvailable: false, // Add whatsappAvailable (assuming it's a boolean)
    assembly: "", // Add assembly
    district: "", // Add district
    state: "", // Add state
    DocumentImage: null, // Add DocumentImage
    igrsNumber: "",
  });

  const [errors, setErrors] = useState({});
  const [currentDateTime, setCurrentDateTime] = useState("");

  const [locations, setLocations] = useState(null);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [assemblies, setAssemblies] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedAssembly, setSelectedAssembly] = useState("");

  // State for search functionality
  const [stateSearch, setStateSearch] = useState("");
  const [districtSearch, setDistrictSearch] = useState("");
  const [filteredStates, setFilteredStates] = useState([]);
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [image, setImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFormData({ ...formData, DocumentImage: file });
    }
  };

  const handleCapture = (event) => {
    const file = event.target.files[0]; // Get the file selected by the user
    if (file) {
      setFormData({
        ...formData,
        DocumentImage: file, // Store the file in formData
      });

      // Preview the image
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // Display image preview
      };
      reader.readAsDataURL(file);
    }
  };

  // Update time every second
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date().toLocaleString());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Fetch categories and visitor ID from the server
  const fetchCategories = async () => {
    try {
      // const token = localStorage.getItem("token");
      // if (!token) {
      //   alert("Authorization token is missing.");
      //   return;
      // }

      const response = await axios.get(`${API_URL}getCategoriesList`, {
        headers: {
          // Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status === "success") {
        setCategories(response.data.data);
        setVisitorId(response.data.visitor_id);
        setVisitPurpose(response.data.visitPurpose || []);

        setFormData((prev) => ({
          ...prev,
          visitorID: response.data.visitor_id,
          purpose: "",
        }));
      } else {
        console.error("Failed to fetch categories:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
  }, []);

  // Save visitor details to the server
  const handleSave = async () => {
    setLoading(true); // Show loader when API request starts

    const token = localStorage.getItem("token");
    if (!token) {
      alert("Authorization token is missing.");
      setLoading(false); // Stop loader
      return;
    }

    const payload = new FormData();
    payload.append("visitor_id", formData.visitorID);
    payload.append("visitor_name", formData.name);
    payload.append("mobile_number", formData.mobileNumber);
    payload.append("categorie_name", formData.category);
    payload.append("email_id", formData.email);
    payload.append("address", formData.address);
    payload.append("visit_purpose", formData.purpose);
    payload.append("to_meet", formData.toMeet);
    payload.append("query", formData.query);
    payload.append("salutation", formData.salutation);
    payload.append("category_text", formData.additionalName);
    payload.append("dob", formData.dob);
    payload.append("whatsapp_tick", formData.whatsappAvailable ? "1" : "0");
    payload.append("assembly", formData.assembly);
    payload.append("district", formData.district);
    payload.append("state", formData.state);
    payload.append("igrs_number", formData.igrsNumber); // Add igrsNumber to the payload

    if (formData.DocumentImage) {
      payload.append("document_image", formData.DocumentImage);
    } else {
      console.log("No document image selected.");
    }

    try {
      const response = await axios.post(
        `${API_URL}createVisitordetails`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === "success") {
        alert("Visitor details saved successfully!");
        setFormData({
          visitorID: visitorId,
          name: "",
          mobileNumber: "",
          category: "",
          email: "",
          address: "",
          purpose: "",
          toMeet: "",
          query: "",
          salutation: "",
          categoryText: "",
          dob: "",
          whatsappTick: "",
          additionalName: "",
          DocumentImage: null,
        });
        setErrors({});
        await fetchCategories();
      } else {
        alert(response.data.message || "Failed to save visitor details.");
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.message || "An unexpected error occurred.");
        if (error.response.data.errors) {
          setErrors(error.response.data.errors);
        }
      } else {
        console.error("An unexpected error occurred:", error);
        alert("An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false); // Stop loader after API response
    }
  };

  // Fetch locations
  useEffect(() => {
    axios
      .post(`${API_URL}locations`, { state_name: null, dist_name1: null })
      .then((response) => {
        if (response.data.success) {
          setLocations(response.data);
          setStates(response.data.states);
          setFilteredStates(response.data.states); // Initialize filtered states

          // If a default state should be selected (e.g., based on a previous value)
          const defaultState = response.data.states[22]; // Set the first state as the default
          setSelectedState(defaultState);

          // Update formData with the default state, keeping the existing fields intact
          setFormData((prevFormData) => ({
            ...prevFormData, // Spread the existing data
            state: defaultState, // Only update the state field
          }));

          // Fetch districts for the default state
          axios
            .post(`${API_URL}locations`, { state_name: defaultState })
            .then((districtResponse) => {
              setDistricts(districtResponse.data.districts || []);
              setFilteredDistricts(districtResponse.data.districts || []); // Initialize filtered districts
            })
            .catch((error) =>
              console.error("Error fetching districts:", error)
            );
        }
      })
      .catch((error) => console.error("Error fetching locations:", error));
  }, []);

  // Update districts when state is selected
  const handleStateChange = (state) => {
    setSelectedState(state);
    setSelectedDistrict(""); // Reset district
    setSelectedAssembly(""); // Reset assembly
    setAssemblies([]); // Reset assemblies
    setDistricts([]); // Reset districts

    // ✅ Ensure state persists
    setFormData((prev) => ({ ...prev, state }));

    axios
      .post(`${API_URL}locations`, { state_name: state })
      .then((response) => {
        setDistricts(response.data.districts || []);
        setFilteredDistricts(response.data.districts || []); // Initialize filtered districts
      })
      .catch((error) => console.error("Error fetching districts:", error));
  };

  const handleDistrictChange = (district) => {
    setSelectedDistrict(district);
    setSelectedAssembly(""); // Reset assembly

    // Update form data for district
    setFormData({ ...formData, district });

    axios
      .post(`${API_URL}locations`, {
        state_name: formData.state, // Using formData.state for consistency
        dist_name1: district,
      })
      .then((response) => {
        setAssemblies(response.data.assemblies || []);
      })
      .catch((error) => console.error("Error fetching assemblies:", error));
  };

  const handleAssemblyChange = (assembly) => {
    setSelectedAssembly(assembly);

    // Update form data for assembly
    setFormData({ ...formData, assembly });
  };

  // Handle state search
  const handleStateSearch = (searchTerm) => {
    setStateSearch(searchTerm);
    setFilteredStates(
      states.filter((state) =>
        state.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  };

  // Handle district search
  const handleDistrictSearch = (searchTerm) => {
    setDistrictSearch(searchTerm);
    setFilteredDistricts(
      districts.filter((district) =>
        district.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  };

  return (
    <div className="mx-auto mx-auto p-6 font-sans bg-white shadow-md rounded-md">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center">
          <img src={Logo} alt="Logo" className="w-40 h-20 " />
          <h2 className="text-2xl font-semibold text-gray-800">Visitor Form</h2>
        </div>
      </div>
      <p className="text-sm text-gray-500 mb-4">
        <strong>Current Date and Time:</strong> {currentDateTime}
      </p>

      <form className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Visitor ID */}
          <div>
            <label
              htmlFor="visitorID"
              className="block text-gray-600 font-medium"
            >
              Visitor ID:
            </label>
            <input
              type="text"
              name="visitorID"
              id="visitorID"
              value={formData.visitorID}
              disabled
              className="w-full p-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed h-10"
            />
          </div>

          {/* Salutation & Name */}
          <div className="flex gap-2 items-end">
            {/* Salutation Dropdown */}
            <div className="w-1/3 md:w-1/4">
              <label
                htmlFor="salutation"
                className="block text-gray-600 font-medium"
              >
                Salutation:
              </label>
              <select
                name="salutation"
                id="salutation"
                value={formData.salutation}
                onChange={handleInputChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 h-10"
                required
              >
                <option value="">Select</option>
                <option value="Mr.">Mr.</option>
                <option value="Ms.">Ms.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Dr.">Dr.</option>
                <option value="Prof.">Prof.</option>
              </select>
            </div>

            {/* Name Input */}
            <div className="w-2/3 md:w-3/4">
              <label htmlFor="name" className="block text-gray-600 font-medium">
                Name:
              </label>
              <input
                type="text"
                name="name"
                id="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter visitor name"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 h-10"
                required
              />
              {errors.visitor_name && (
                <p className="text-red-500 text-sm">{errors.visitor_name[0]}</p>
              )}
            </div>
          </div>

          {/* Mobile Number & WhatsApp Checkbox */}
          <div className="flex flex-col md:flex-row md:items-end gap-2">
            {/* Mobile Number Input */}
            <div className="md:w-3/4 w-full">
              <label
                htmlFor="mobileNumber"
                className="block text-gray-600 font-medium"
              >
                Mobile Number:
              </label>
              <input
                type="tel"
                name="mobileNumber"
                id="mobileNumber"
                value={formData.mobileNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                  if (value.length <= 10) {
                    handleInputChange({
                      target: { name: "mobileNumber", value },
                    });
                  }
                }}
                placeholder="Enter mobile number"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 h-10"
                required
              />
              {formData.mobileNumber.length > 0 &&
                formData.mobileNumber.length !== 10 && (
                  <p className="text-red-500 text-sm">
                    Mobile number must be 10 digits long.
                  </p>
                )}
              {errors.mobile_number && (
                <p className="text-red-500 text-sm">
                  {errors.mobile_number[0]}
                </p>
              )}
            </div>

            {/* WhatsApp Checkbox */}
            <div className="md:w-1/4 w-full flex items-center gap-2 mt-2 md:mt-0">
              <input
                type="checkbox"
                id="whatsappAvailable"
                checked={formData.whatsappAvailable}
                onChange={(e) =>
                  handleInputChange({
                    target: {
                      name: "whatsappAvailable",
                      value: e.target.checked ? 1 : 0,
                    },
                  })
                }
                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <label
                htmlFor="whatsappAvailable"
                className="text-gray-600 font-medium flex items-center gap-1"
              >
                <FaWhatsapp className="text-green-500 w-10 h-10" />{" "}
                {/* Bigger WhatsApp Icon */}
              </label>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label
              htmlFor="category"
              className="block text-gray-600 font-medium"
            >
              Category:
            </label>
            <select
              name="category"
              id="category"
              value={formData.category}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 h-10"
              required
            >
              <option value="">Select Category</option>
              {categories.map((category) => (
                <option key={category.id} value={category.name}>
                  {category.name}
                </option>
              ))}
            </select>
            {errors.categorie_name && (
              <p className="text-red-500 text-sm">{errors.categorie_name[0]}</p>
            )}
          </div>

          {/* Show additional text box if "Other" or "VIP" is selected */}
          {(formData.category === "Others" || formData.category === "VIP") && (
            <div className="mt-2">
              <label
                htmlFor="additionalName"
                className="block text-gray-600 font-medium"
              >
                Enter Name:
              </label>
              <input
                type="text"
                id="additionalName"
                name="additionalName"
                value={formData.additionalName}
                onChange={handleInputChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400"
                placeholder="Enter the name"
              />
            </div>
          )}

          <div>
            <label htmlFor="email" className="block text-gray-600 font-medium">
              Email ID:
            </label>
            <input
              type="text"
              name="email"
              id="email"
              value={formData.email}
              onChange={(e) => {
                const value = e.target.value;
                // Update the formData with email input
                handleInputChange({
                  target: { name: "email", value },
                });
              }}
              placeholder="Enter email id"
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400"
              required
            />
            {formData.email.length > 0 && (
              <p className="text-red-500 text-sm">
                {formData.email.length < 5
                  ? "Email must be at least 5 characters long"
                  : ""}
                {formData.email &&
                  !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                    formData.email
                  ) &&
                  "Email must be a valid format (e.g., example@domain.com)"}
              </p>
            )}
            {errors.email_id && (
              <p className="text-red-500 text-sm">{errors.email_id[0]}</p>
            )}
          </div>

          <div>
            <label
              htmlFor="address"
              className="block text-gray-600 font-medium"
            >
              Address:
            </label>
            <input
              type="text"
              name="address"
              id="address"
              value={formData.address}
              onChange={handleInputChange}
              placeholder="Enter address"
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400"
              required
            />
            {errors.address && (
              <p className="text-red-500 text-sm">{errors.address[0]}</p>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label htmlFor="toMeet" className="block text-gray-600 font-medium">
              To Meet:
            </label>
            <input
              type="text"
              name="toMeet"
              id="toMeet"
              value={formData.toMeet}
              onChange={handleInputChange}
              placeholder="Enter the person to meet"
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400"
              required
            />
            {errors.to_meet && (
              <p className="text-red-500 text-sm">{errors.to_meet[0]}</p>
            )}
          </div>

          <div>
            <label
              htmlFor="purpose"
              className="block text-gray-600 font-medium"
            >
              Purpose:
            </label>
            <select
              name="purpose"
              id="visitPurpose"
              value={formData.purpose}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 h-10"
              required
            >
              <option value="">Select Purpose of Visit</option>
              {visitPurpose.map((purpose) => (
                <option
                  key={purpose.visit_purpose}
                  value={purpose.visit_purpose}
                >
                  {purpose.visit_purpose}
                </option>
              ))}
            </select>
            {errors.visit_purpose && (
              <p className="text-red-500 text-sm">{errors.visit_purpose[0]}</p>
            )}
          </div>
          <div>
            <label htmlFor="dob" className="block text-gray-600 font-medium">
              Date of Birth:
            </label>
            <input
              type="date"
              name="dob"
              id="dob"
              value={formData.dob}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 h-10"
              required
            />
            {errors.dob && (
              <p className="text-red-500 text-sm">{errors.dob[0]}</p>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <label className="block text-lg font-medium text-gray-700">
              State:
            </label>
            <input
              type="text"
              placeholder="Search State"
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 mb-2"
              onChange={(e) => handleStateSearch(e.target.value)}
            />
            <select
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 h-10"
              value={formData.state} // Use formData.state
              onChange={(e) => handleStateChange(e.target.value)}
            >
              <option value="">Select State</option>
              {filteredStates.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

          {selectedState && (
            <div className="flex flex-col">
              <label className="block text-lg font-medium text-gray-700">
                District:
              </label>
              <input
                type="text"
                placeholder="Search District"
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 mb-2"
                onChange={(e) => handleDistrictSearch(e.target.value)}
              />
              <select
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 h-10"
                value={formData.district} // Use formData.district
                onChange={(e) => handleDistrictChange(e.target.value)}
              >
                <option value="">Select District</option>
                {filteredDistricts.map((district) => (
                  <option key={district} value={district}>
                    {district}
                  </option>
                ))}
              </select>
            </div>
          )}

          {selectedDistrict && (
            <div className="flex flex-col">
              <label className="block text-lg font-medium text-gray-700">
                Assembly:
              </label>
              <select
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 h-10"
                value={formData.assembly}
                onChange={(e) =>
                  setFormData({ ...formData, assembly: e.target.value })
                }
              >
                <option value="">Select Assembly</option>
                {assemblies.map((assembly) => (
                  <option key={assembly} value={assembly}>
                    {assembly}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* IGRS/Jansunwai Number Input */}
          <div className="space-y-4">
            <label
              htmlFor="igrsNumber"
              className="block text-gray-700 font-semibold"
            >
              IGRS/Jansunwai Number:
            </label>
            <input
              type="text"
              name="igrsNumber"
              id="igrsNumber"
              value={formData.igrsNumber}
              onChange={handleInputChange}
              placeholder="Enter IGRS/Jansunwai Number"
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 shadow-md"
              required
            />
            {errors.igrsNumber && (
              <p className="text-red-500 text-sm">{errors.igrsNumber[0]}</p>
            )}
          </div>

          {/* Upload Document Section */}
          <div className="space-y-4">
            <label
              htmlFor="document"
              className="block text-gray-700 font-semibold"
            >
              Upload Document:
            </label>
            <div className="flex items-center gap-4">
              {/* Hidden File Input for Camera */}
              <input
                type="file"
                accept="image/*"
                capture="environment"
                id="document"
                onChange={handleCapture} // Handle file selection
                className="hidden"
              />

              {/* Camera Button */}
              <label
                htmlFor="document"
                className="p-3 bg-blue-500 text-white rounded-md cursor-pointer hover:bg-blue-600 transition duration-300 transform hover:scale-105"
              >
                📷 Open Camera
              </label>

              {/* Image Preview */}
              {image && (
                <div className="flex justify-center items-center mt-2">
                  <img
                    src={image}
                    alt="Captured Document"
                    className="w-20 h-20 object-cover rounded-lg border-2 border-gray-300 shadow-md"
                  />
                </div>
              )}
            </div>

            {/* Error Message */}
            {errors.document_image && (
              <p className="text-red-500 text-sm">{errors.document_image[0]}</p>
            )}
          </div>

          {/* Query Input */}
          <div className="space-y-4">
            <label
              htmlFor="query"
              className="block text-gray-700 font-semibold"
            >
              Type Your Query Here:
            </label>
            <textarea
              name="query"
              id="query"
              value={formData.query}
              onChange={handleInputChange}
              placeholder="Enter your query here"
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 shadow-md"
              rows="4"
              required
            ></textarea>
            {errors.query && (
              <p className="text-red-500 text-sm">{errors.query[0]}</p>
            )}
          </div>
        </div>

        <div className="flex justify-center mt-6">
          <button
            type="button"
            onClick={handleSave}
            className={`px-6 py-2 rounded-md text-white focus:ring-2 focus:ring-blue-400 ${
              loading
                ? "bg-gray-500 cursor-not-allowed"
                : "bg-[#068800] hover:bg-blue-600"
            }`}
            disabled={loading} // Disable button when loading
          >
            {loading ? (
              <div className="flex items-center">
                <svg
                  className="animate-spin h-5 w-5 mr-2 text-white"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v2.5a5.5 5.5 0 00-5.5 5.5H4z"
                  ></path>
                </svg>
                Saving...
              </div>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PublicForm;
